/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 29/3/2023
 */

import { apiSlice } from '../Slices/apiSlice';

export const userService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllUser: builder.query({
      query: () => "/sec-users",
      providesTags: ["user"],
    }),

    getUserById: builder.query({
      query: (userId) => `/sec-users/${userId}`, 
      providesTags: ["user"],
    }),

    createUser: builder.mutation({
      query: (UserDetails) => ({
        url: `/sec-users`,
        method: "POST",
        body: UserDetails,
      }),
      invalidatesTags: ["user"],
    }),

    createGuest: builder.mutation({
      query: (UserDetails) => ({
              url: '/sec-users/guest-customer',
              method: 'POST',
              body: UserDetails,
      }),
  }),

    updateUser: builder.mutation({
      query: (userDetails) => ({
      url: `/sec-users/${userDetails.userId}`,
        method: "PUT",
        body: userDetails,  
      }),
      invalidatesTags: ["user"],
    }),
    
    deleteUser: builder.mutation({
      query: (userId) => ({
        url: `/sec-users/${userId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["user"],
    }),

    getUserBr: builder.query({
      query: () => "/sec-br",
      invalidatesTags:['user']
    }),

    getUserGenders: builder.query({
      query: () => "/genders",
      invalidatesTags:['user']
    }),

    getUserMaritalStatuses: builder.query({
      query: () => "/marital-statuses",
      invalidatesTags:['user']
    }),

  }),
});

export const {
  useGetAllUserQuery,
  useGetUserByIdQuery,
  useCreateUserMutation,
  useCreateGuestMutation,
  useUpdateUserMutation,
  useDeleteUserMutation,
  useGetUserBrQuery,
  useGetUserGendersQuery,
  useGetUserMaritalStatusesQuery,
} = userService;
